export default __webpack_public_path__ + "static/media/client3.1c746603.jpg";